let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4aLlP"), load("aZinD"), load("6gqpV"), load("69mq0"), load("bbnaa"), load("56uR7"), load("f9WnJ")]).then(() => parcelRequire('gVFlX'));